// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import 'app/scripts/views/internal/data-transfer/DragDropEvents';

import Promise from 'bluebird';
import _ from 'underscore';
// eslint-disable-next-line no-restricted-imports
import parseUrl from 'url-parse';

import NotificationDirectIcon from '@atlaskit/icon/glyph/notification-direct';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { doesCardOnlyHaveName } from '@trello/card-roles';
import { renderComponent } from '@trello/component-wrapper';
import { featureFlagClient } from '@trello/feature-flag-client';
import { localizeCount } from '@trello/i18n';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';
import ReactDOM from '@trello/react-dom-wrapper';
import { idCache } from '@trello/shortlinks';
import { getSmartCardClient } from '@trello/smart-card/smart-card-client';
import { ListTestIds } from '@trello/test-ids';
import { parseTrelloUrl } from '@trello/urls';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { l } from 'app/scripts/lib/localize';
import { sendPluginTrackEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
import { trelloClipboard } from 'app/scripts/lib/trello-clipboard';
import { ninvoke } from 'app/scripts/lib/util/ninvoke';
import { removeAllRanges } from 'app/scripts/lib/util/removeAllRanges';
import type { Board } from 'app/scripts/models/Board';
import type { Card } from 'app/scripts/models/Card';
import {
  canAddCard,
  maybeDisplayLimitsErrorOnCardAdd,
} from 'app/scripts/views/card/CardLimitsError';
import { CardListView } from 'app/scripts/views/card/CardListView';
import { getSeparatorClassName } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';
import { CardComposerInlineView } from 'app/scripts/views/card-composer/CardComposerInlineView';
import { pastedFileName } from 'app/scripts/views/internal/pastedFileName';
import { PasteInput } from 'app/scripts/views/internal/PasteInput';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { View } from 'app/scripts/views/internal/View';
import { warnIfFileTooLarge } from 'app/scripts/views/internal/warnIfFileTooLarge';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { ListMenuView } from 'app/scripts/views/list/ListMenuView';
import { ListTemplate } from 'app/scripts/views/templates/ListTemplate';
import { boardModelIdToElementState } from 'app/src/boardModelIdToElementState';
import { CardTemplatesButton } from 'app/src/components/CardTemplatesPopover';
import { isBoardCanvasModernizationEnabled } from 'app/src/isBoardCanvasModernizationEnabled';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface ListViewEvents {
  on(
    name: 'moveCard',
    callback: (args: { shortLink: string; idList: string }) => void,
  ): this;
  on(
    name: 'copyCard',
    callback: (args: {
      shortLink: string;
      idList: string;
      traceId: string;
    }) => void,
  ): this;
  off(
    name: 'moveCard',
    callback: (args: { shortLink: string; idList: string }) => void,
  ): this;
  off(
    name: 'copyCard',
    callback: (args: {
      shortLink: string;
      idList: string;
      traceId: string;
    }) => void,
  ): this;
}

export interface ListView {
  cardListView: CardListView;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fEditingName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pluginActions: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pluginActionsExpiry: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pluginActionsPromise: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderComposerDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderListLimitDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderNameDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toggleComposerLinkDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uniqueId: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountSubscribedToListIcon: any;
}

export class ListView
  extends View<Board, { deferCards: boolean; renderedFromReact: boolean }>
  implements ListViewEvents
{
  className() {
    if (this.options.renderedFromReact) {
      return 'js-list list-wrapper';
    }
    return 'js-list list-wrapper list-wrapper-with-margins';
  }

  events() {
    return {
      'mouseenter .js-open-list-menu': 'preloadMenu',
      'click .js-open-list-menu': 'openMenu',
      'mousedown .list-cards': 'eventStopPropagation',
      'click .js-open-card-composer': 'openCardComposer',

      'keydown  .js-list-name-input': 'keyDownEvent',
      'blur     .js-list-name-input': 'stopEditing',

      'click    .js-editing-target': 'startEditing',
      'focus    .js-list-name-input': 'startEditing',

      movelist: 'moveList',

      sortreceive: 'sortReceive',
      sortcommit: 'sortCommit',

      'dd-drop:files': 'dropFiles',
      'dd-drop:text': 'dropText',
      'dd-drop:url': 'dropUrl',

      mouseenter: 'mouseenter',
      mouseleave: 'mouseleave',
      mousemove: 'mousemove',
      'pasteinput:text': 'dropText',
      'pasteinput:files': 'dropFiles',
      'pasteinput:url': 'dropUrl',
    };
  }

  initialize() {
    super.initialize(...arguments);

    this.fEditingName = false;

    this.makeDebouncedMethods(
      'render',
      'toggleComposerLink',
      'renderComposer',
      'renderCardCount',
      'renderName',
      'renderListLimit',
    );

    this.listenTo(this.model, {
      'change:limits': this.renderLimits,
      'change:name': this.renderNameDebounced,
      'change:subscribed': this.renderSubscribed,
      'change:softLimit': this.renderListLimit,
      'change:id': this.onIdChange,
    });

    this.listenTo(this.model.cardList, {
      'add remove change:idList change:closed reset'() {
        this.renderCardCountDebounced();
        return this.renderListLimitDebounced();
      },
    });

    this.listenTo(this.model.getBoard().boardPluginList, 'add remove', () => {
      this.renderListLimitDebounced();
    });

    this.listenTo(this.model.getBoard(), 'permChange', this.renderEditable);

    this.listenTo(this.model.getBoard().composer, {
      'change:list change:index change:vis': this.renderComposerDebounced,
      'change:list change:vis'() {
        return this.toggleComposerLinkDebounced();
      },
    });

    this.listenTo(this.model.getBoard(), {
      'change:prefs.isTemplate': this.renderDebounced,
    });

    this.cardListView = this.collectionSubview(
      CardListView,
      this.model.cardList,
      {
        className: 'list-cards u-fancy-scrollbar js-list-cards',
        deferCards: this.options.deferCards,
      },
    );

    // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    $(window).on(`resize.${this.uniqueId()}`);

    for (const eventName of [
      'mouseEnterCardView',
      'mouseLeaveCardView',
      'mouseMoveCardView',
    ]) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      ((eventName) =>
        this.listenTo(
          this.cardListView,
          eventName,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          function (this: any, cardView: any) {
            this.trigger(eventName, cardView);
          },
        ))(eventName);
    }
  }

  renderLimits() {
    const limited = !canAddCard({ destinationList: this.model });
    this.cardListView.$el.toggleClass('card-limits-full', limited);
    return this;
  }

  render() {
    this.el.setAttribute('data-testid', ListTestIds.ListWrapper);
    this.cardListView.$el.detach();

    this.$el.html(
      ListTemplate({
        name: this.model.get('name'),
        subscribed: this.model.get('subscribed'),
        loggedIn: Auth.isLoggedIn(),
        editable: this.model.editable(),
        isTemplate: this.model.isTemplate(),
      }),
    );

    this.cardListView.$el.insertAfter($('.js-list-header', this.$el));
    this.cardListView.render();
    this.cardListView.$el.toggleClass('js-sortable', this.model.editable());

    this.renderLimits();

    this.renderListLimit();

    this.toggleComposerLinkDebounced();
    this.renderComposerDebounced();

    this.renderCardCount();
    this.renderEditable();

    this.renderCardTemplateButton();
    this.renderSubscribeIcon();

    // The short delay causes the UI thread to complete before calling autosize.
    // We'll call autosize in react's componentDidMount when it comes to this
    // view eventually.
    _.defer(() => {
      // @ts-expect-error TS(2339): Property 'autosize' does not exist on type 'JQuery... Remove this comment to see the full error message
      $('.js-list-name-input', this.$el).autosize({ append: false });
    });

    return this;
  }

  remove() {
    $(window).off(`.${this.uniqueId()}`);
    this.removeCardTemplateButton();
    if (typeof this.unmountSubscribedToListIcon === 'function') {
      this.unmountSubscribedToListIcon();
      this.unmountSubscribedToListIcon = null;
    }
    return super.remove(...arguments);
  }

  renderName() {
    $('.js-list-name-assist', this.$el).text(this.model.get('name'));

    // don't update while your typing.
    if (!this.fEditingName) {
      $('.js-list-name-input', this.$el)
        .val(this.model.get('name'))
        .trigger('autosize.resize', false);
    }

    return this;
  }

  renderSubscribed() {
    $('.js-list-subscribed', this.$el).toggleClass(
      'hide',
      !(this.model.get('subscribed') ?? false),
    );

    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
    return this;
  }

  renderSubscribeIcon() {
    const element = this.el.querySelector('.icon-subscribe-container');

    if (element) {
      this.unmountSubscribedToListIcon = renderComponent(
        <NotificationDirectIcon label="" size="small" />,
        element,
      );
    }
    return this;
  }

  renderEditable() {
    // NOTE: The best thing to do here is probably to toggle an 'editable' or
    // 'readonly' class on the $el, and use CSS to control the visibility of
    // things.  Not making this change because a lot of the templates are being
    // re-written.
    const editable = this.model.editable();

    $('.js-list-cards', this.$el).toggleClass('js-sortable', editable);

    if (!editable) {
      $('.js-list-name-input', this.$el).prop('disabled', true);
    } else {
      $('.js-list-name-input', this.$el).prop('disabled', false);
    }

    $('.js-open-card-composer', this.$el).toggleClass('hide', !editable);

    DragSort.refreshListCardSortable();

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveListName(e: any) {
    const $input = $('.js-list-name-input', this.$el);

    const name = this.model.get('name');
    let newValue = $input.val();

    // remove new lines and extra whitespace
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    newValue = newValue.replace(/\s+/g, ' ').trim();

    // if it's the same name, don't save
    if (newValue === name) {
      return;
    }

    // if it's too long, don't save
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (newValue.length > 16384) {
      return;
    }

    // don't save if empty.
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (newValue.trim().length === 0) {
      return;
    }

    const traceId = Analytics.startTask({
      taskName: 'edit-list/name',
      source: 'listHeader',
    });

    const boardId = this.model.getBoard()?.id;

    this.model.update(
      { name: newValue, traceId },
      tracingCallback(
        {
          taskName: 'edit-list/name',
          source: 'listHeader',
          traceId,
        },
        (err) => {
          if (!err) {
            Analytics.sendTrackEvent({
              action: 'edited',
              actionSubject: 'listName',
              source: 'listHeader',
              containers: {
                board: {
                  id: boardId,
                },
              },
              attributes: {
                taskId: traceId,
              },
            });
          }
        },
      ),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyDownEvent(e: any) {
    if (getKey(e) === Key.Enter) {
      stopPropagationAndPreventDefault(e); // prevents new lines.
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.stopEditing();
      return;
    }

    if (getKey(e) === Key.Escape) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.stopEditing();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  startEditing(e: any) {
    stopPropagationAndPreventDefault(e);
    if (!this.fEditingName && this.model.editable() && !DragSort.sorting) {
      this.fEditingName = true;

      $('.js-editing-target', this.$el).addClass('is-hidden');

      _.defer(() => {
        $('.js-list-name-input', this.$el)
          .focus()
          .select()
          .addClass('is-editing');
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stopEditing(e: any) {
    if (this.fEditingName) {
      $('.js-editing-target', this.$el).removeClass('is-hidden');

      const $input = $('.js-list-name-input', this.$el).removeClass(
        'is-editing',
      );
      if ($input.is(':focus')) {
        $input.blur();
      }
      removeAllRanges();

      this.fEditingName = false;
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.saveListName();
      this.renderNameDebounced();
    }
  }

  toggleComposerLink() {
    const isHidden = this.composerOpen() || !this.model.editable();

    $('.js-open-card-composer', this.$el).toggleClass('hide', isHidden);
    $('.js-card-composer-container', this.$el).toggleClass('hide', isHidden);
    $('.js-list-cards', this.$el).toggleClass('has-margin-bottom', isHidden);
  }

  composerOpen() {
    const composer = this.model.getBoard()?.composer;
    return composer?.get('vis') && composer.get('list') === this.model;
  }

  renderComposer() {
    if (this.composerOpen()) {
      const { composer } = this.model.getBoard();
      const view = Controller.getCurrentBoardView();
      const composerView = view?.subview(CardComposerInlineView, composer);
      this.insertComposerAtIndex(composer.get('index'), composerView);
      composerView.scrollIntoView();
      _.debounce(composerView.delegateEvents(), 150);
    }

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertComposerAtIndex(index: any, composerView: any) {
    if (index === 0) {
      $('.list-cards', this.$el).prepend(composerView.render().el);
    } else {
      let cardIndex = index - 1;

      const $cards = $('.list-card', this.$el).not('.js-composer');
      if (cardIndex >= $cards.length) {
        cardIndex = $cards.length - 1;
      }
      $cards.eq(cardIndex).after(composerView.render().el);
    }
  }

  renderCardCount() {
    return $('.js-num-cards', this.$el).text(
      localizeCount('cards', this.model.openCards().length),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openCardComposer(e: any) {
    stopPropagationAndPreventDefault(e);

    PopOver.hide();

    const board = this.model.getBoard();
    const options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: this.model,
    };
    if (maybeDisplayLimitsErrorOnCardAdd(options)) {
      return;
    }

    board.composer.save({
      list: this.model,
      index: this.model.openCards().length,
      vis: true,
    });

    Analytics.sendClickedButtonEvent({
      buttonName: 'addAnotherCardButton',
      source: 'listFooter',
      containers: {
        board: {
          id: board?.id,
        },
        list: {
          id: this.model?.id,
        },
        organization: {
          id: board?.getOrganization()?.id,
        },
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  triggerOnItem(e: any, ui: any, sEvent: any) {
    e?.stopPropagation();

    // Don't kick off any re-renders until sortable puts the card in the DOM
    this.defer(() => ui.item.trigger(sEvent, [ui, this]));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortReceive(e: any, ui: any) {
    this.triggerOnItem(e, ui, 'moveto');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortCommit(e: any, ui: any) {
    this.triggerOnItem(e, ui, 'movein');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadPluginActions(target: any, timeout: any) {
    return pluginRunner
      .all({
        timeout,
        command: 'list-actions',
        el: target,
        board: this.model.getBoard(),
        list: this.model,
      })
      .catch(() => [])
      .then((pluginActions) =>
        // limit to three actions per plugin
        _.chain(pluginActions)
          .groupBy('idPlugin')
          .map((val, idPlugin) => val.slice(0, 3))
          .flatten()
          .value(),
      );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  preloadMenu(e: any) {
    if (
      !DragSort.sorting &&
      this.pluginActionsPromise /* eslint-disable-line eqeqeq */ == null
    ) {
      return (this.pluginActionsPromise = this.loadPluginActions(
        e.currentTarget,
        500,
      ).then((pluginActions) => {
        this.pluginActionsPromise = null;
        this.pluginActions = pluginActions;
        this.pluginActionsExpiry = Date.now() + 5000;
        return pluginActions;
      }));
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMenu(e: any) {
    if (!DragSort.sorting) {
      e?.preventDefault();

      Analytics.sendClickedButtonEvent({
        buttonName: 'listMenuButton',
        source: 'listHeader',
        containers: {
          board: {
            id: this.model?.getBoard()?.id,
          },
          list: {
            id: this.model?.id,
          },
          organization: {
            id: this.model?.getBoard()?.getOrganization()?.id,
          },
        },
      });

      let pluginActions = [];

      if (
        this.pluginActions /* eslint-disable-line eqeqeq */ != null &&
        this.pluginActionsExpiry > Date.now()
      ) {
        ({ pluginActions } = this);
      } else if (
        this.pluginActionsPromise /* eslint-disable-line eqeqeq */ != null
      ) {
        pluginActions = this.pluginActionsPromise;
      } else {
        // @ts-expect-error TS(2740): Type 'Bluebird<any[]>' is missing the following pr... Remove this comment to see the full error message
        pluginActions = this.loadPluginActions(e.currentTarget, 150);
      }

      // eslint-disable-next-line @typescript-eslint/no-shadow
      Promise.resolve(pluginActions).then((pluginActions) => {
        PopOver.toggle({
          elem: e.currentTarget,
          // @ts-expect-error
          view: new ListMenuView({
            model: this.model,
            pluginActions,
          }),
        });
        return (this.pluginActions = null);
      });

      return false;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveList(e: any, ui: any) {
    stopPropagationAndPreventDefault(e);
    const lists = ui.item.parent().children();
    const pos = lists.index(ui.item);
    this.model.move(pos);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventStopPropagation(e: any) {
    e?.stopPropagation();
  }

  scrollToCard(card: Card) {
    if (!isBoardCanvasModernizationEnabled()) {
      const cardView = this.cardListView.viewForModel(card);
      return cardView.el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }

    const cardElement = boardModelIdToElementState.value.cards.get(
      card.get('id'),
    );
    if (!cardElement) {
      return;
    }

    const parent = this.el.querySelector<HTMLElement>('.js-list-cards');

    if (!parent) {
      return;
    }

    cardElement.scrollIntoView({ behavior: 'smooth' });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseenter(e: any) {
    this.trigger('mouseEnterListView');
    return PasteInput.addHandler(this, { scope: 'list' });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseleave(e: any) {
    this.trigger('mouseLeaveListView');
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
    return PasteInput.removeHandler(this, { scope: 'list' });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mousemove(e: any) {
    return this.trigger('mouseMoveListView');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dropText(e: any) {
    if (!this.model.editable()) {
      return;
    }

    const board = this.model.getBoard();
    const options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: this.model,
      hasAttachments: true,
    };
    if (maybeDisplayLimitsErrorOnCardAdd(options)) {
      return;
    }

    const text = e.detail;

    const traceId = Analytics.startTask({
      taskName: 'create-card/paste-text',
      source: 'cardFromClipboard',
    });

    return ninvoke(this.model, 'uploadText', text, traceId)
      .then((data) => {
        Analytics.sendTrackEvent({
          action: 'created',
          actionSubject: 'card',
          source: 'cardFromClipboard',
          containers: {
            board: { id: this.model.getBoard().id },
            list: { id: this.model.id },
            // @ts-expect-error
            card: { id: data?.id },
          },
          attributes: {
            taskId: traceId,
          },
        });

        Analytics.taskSucceeded({
          taskName: 'create-card/paste-text',
          traceId,
          source: 'cardFromClipboard',
        });
      })
      .catch((error) => {
        throw Analytics.taskFailed({
          taskName: 'create-card/paste-text',
          traceId,
          source: 'cardFromClipboard',
          error,
        });
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dropUrl(e: any) {
    if (!this.model.editable()) {
      return;
    }

    const board = this.model.getBoard();
    const options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: this.model,
      hasAttachments: true,
    };
    if (maybeDisplayLimitsErrorOnCardAdd(options)) {
      return;
    }

    e.stopPropagation();
    const url = e.detail;

    if (board.attachmentUrlRestricted(url)) {
      return;
    }

    const parsedTrello = parseTrelloUrl(url);
    if (parsedTrello.type === 'card') {
      this.handlePastedCardUrl(parsedTrello.shortLink, url);
    } else {
      this.createCardFromUrl({ url });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handlePastedCardUrl(shortLink: any, url: any) {
    let traceId = '';
    return Promise.try(() => {
      const idCard = idCache.getId('Card', shortLink) ?? shortLink;
      const card = ModelCache.get('Card', idCard);
      if (card /* eslint-disable-line eqeqeq */ != null) {
        return card;
      }
      return ModelLoader.loadCardData(idCard);
    })
      .then((card) =>
        Promise.try(() => {
          const board = card.getBoard();
          if (board?.get('memberships')?.length) {
            return board;
          }
          return ModelLoader.loadBoardMinimal(this.get('idBoard'));
        }).then((board) => {
          let me;
          const isCut = trelloClipboard.isCut(url) && board.editable();
          const isCopy = !isCut;
          const event = isCut ? 'moveCard' : 'copyCard';
          if (isCopy) {
            traceId = Analytics.startTask({
              taskName: 'create-card/paste-url',
              source: 'powerUpCardFromTrelloUrl',
            });
          }
          if (board.get('enterpriseOwned')) {
            const isGuest = board.isGuest(Auth.me());
            if (
              isGuest &&
              board.get('id') !== this.model.getBoard().get('id')
            ) {
              Alerts.show(
                [
                  'can only copy within board',
                  {
                    boardName: board.get('name'),
                  },
                ],
                'error',
                'trello-clipboard',
                5000,
              );
              if (isCopy) {
                Analytics.taskFailed({
                  taskName: 'create-card/paste-url',
                  traceId,
                  error: new Error('can only copy within board'),
                  source: 'powerUpCardFromTrelloUrl',
                });
              }
              return;
            } else if (
              board.getOrganization()?.get('idEnterprise') !==
              this.model.getBoard().getOrganization()?.get('idEnterprise')
            ) {
              Alerts.show(
                [
                  'can only copy within enterprise',
                  {
                    enterpriseName: board.getEnterprise()?.get?.('displayName'),
                  },
                ],
                'error',
                'trello-clipboard',
                5000,
              );
              if (isCopy) {
                Analytics.taskFailed({
                  taskName: 'create-card/paste-url',
                  traceId,
                  error: new Error('can only copy within enterprise'),
                  source: 'powerUpCardFromTrelloUrl',
                });
              }
              return;
            }
          }

          this.trigger(event, {
            shortLink,
            idList: this.model.id,
            traceId,
          });

          if (isCopy) {
            Analytics.sendTrackEvent({
              action: 'created',
              actionSubject: 'card',
              source: 'powerUpCardFromTrelloUrl',
              containers: {
                board: { id: this.model.getBoard().id },
                list: { id: this.model.id },
              },
              attributes: {
                taskId: traceId,
              },
            });
            Analytics.taskSucceeded({
              taskName: 'create-card/paste-url',
              traceId,
              source: 'powerUpCardFromTrelloUrl',
            });
          }

          if ((me = Auth.me())) {
            const oneTimeMessage = `pasteAlert-${event}`;
            if (!me.isDismissed(oneTimeMessage)) {
              return me.dismiss(oneTimeMessage);
            }
          }
        }),
      )
      .catch((e) => {
        if (traceId) {
          Analytics.taskFailed({
            taskName: 'create-card/paste-url',
            traceId,
            source: 'powerUpCardFromTrelloUrl',
            error: e,
          });
        }
        return this.createCardFromUrl({ url });
      });
  }

  createCardFromUrl({
    url,
    analyticsTaskName = 'create-card/paste-url',
    analyticsSource = 'powerUpCardFromUrl',
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any) {
    const smartCardClient = getSmartCardClient();

    const analyticsContainers = {
      board: { id: this.model.getBoard()?.id },
      list: { id: this.model.id },
      enterprise: {
        id: this.model.getBoard()?.get('idEnterprise'),
      },
      organization: {
        id: this.model?.getBoard()?.getOrganization()?.id,
      },
    };

    return new Promise((resolve, reject) => {
      const traceId = Analytics.startTask({
        taskName: analyticsTaskName,
        source: analyticsSource,
        containers: analyticsContainers,
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let domain: any;
      const parsed = parseUrl(url);
      if ((domain = parsed.host) /* eslint-disable-line eqeqeq */ != null) {
        return (
          pluginRunner
            .one({
              timeout: 2000,
              command: 'card-from-url',
              list: this.model,
              board: this.model.getBoard(),
              options: {
                url,
              },
            })
            // @ts-expect-error TS(2339): Property 'Error' does not exist on type 'PluginRun... Remove this comment to see the full error message
            .catch(pluginRunner.Error.NotHandled, () => ({}))
            .then(async (dataFromPlugin) => {
              const placeholder = l('loading from domain', { domain });
              const cardData = _.pick(dataFromPlugin, 'name', 'desc');

              let createCardPromise;

              // Only create a Link card here if there was no cardData provided by a plugin.
              const hasData = cardData && Object.keys(cardData).length > 0;

              if (!hasData) {
                const resolvedUrl = await smartCardClient
                  .fetchData(url)
                  .catch(() => {});

                // We only want to create a Link card if it can be resolved with the ORS.
                if (resolvedUrl) {
                  createCardPromise = ninvoke(
                    this.model.cardList,
                    'create',
                    {
                      name: url,
                      pos: this.model.bottomCardPos(),
                    },
                    {
                      traceId,
                    },
                  );
                }
              }

              if (!createCardPromise) {
                createCardPromise = ninvoke(
                  this.model,
                  'uploadUrl',
                  url,
                  cardData,
                  placeholder,
                  traceId,
                );
              }

              try {
                const data = await createCardPromise;
                // there might not be a idPlugin if the client
                // doesn't find a power-up match for this url
                // @ts-expect-error
                if (dataFromPlugin?.idPlugin) {
                  return sendPluginTrackEvent({
                    // @ts-expect-error
                    idPlugin: dataFromPlugin.idPlugin,
                    idBoard: this.model.getBoard().id,
                    // @ts-expect-error
                    idCard: data.id,
                    event: {
                      action: 'created',
                      actionSubject: 'card',
                      source: 'powerUpCardFromUrl',
                      attributes: {
                        taskId: traceId,
                      },
                    },
                  });
                } else {
                  Analytics.sendTrackEvent({
                    action: 'created',
                    actionSubject: 'card',
                    source: analyticsSource,
                    containers: {
                      ...analyticsContainers,
                      // @ts-expect-error
                      card: { id: data?.id },
                    },
                    attributes: {
                      taskId: traceId,
                    },
                  });
                }
                Analytics.taskSucceeded({
                  taskName: analyticsTaskName,
                  traceId,
                  source: analyticsSource,
                  containers: {
                    ...analyticsContainers,
                    // @ts-expect-error
                    card: { id: data?.id },
                  },
                });
              } catch (error) {
                throw Analytics.taskFailed({
                  taskName: analyticsTaskName,
                  traceId,
                  source: analyticsSource,
                  containers: analyticsContainers,
                  error,
                });
              }
            })
            .done(() => resolve())
        );
      }
      return resolve();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dropFiles(e: any) {
    if (!this.model.editable()) {
      return;
    }

    const board = this.model.getBoard();

    if (board.attachmentTypeRestricted('computer')) {
      return;
    }

    const options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: this.model,
      hasAttachments: true,
    };
    if (maybeDisplayLimitsErrorOnCardAdd(options)) {
      return;
    }

    const files = e.detail;

    if (warnIfFileTooLarge(this.model.getBoard(), files)) {
      return;
    }

    return Promise.resolve(files)
      .each((file) => {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const name = file.name || pastedFileName();

        const traceId = Analytics.startTask({
          taskName: 'create-card/paste-file',
          source: 'cardFromClipboard',
        });

        return ninvoke(this.model, 'upload', file, name, traceId).then(
          (data) => {
            if (data) {
              Analytics.sendTrackEvent({
                action: 'created',
                actionSubject: 'card',
                source: 'cardFromClipboard',
                containers: {
                  board: { id: this.model?.getBoard()?.id },
                  list: { id: this.model?.id },
                  // @ts-expect-error
                  card: { id: data?.id },
                },
                attributes: {
                  taskId: traceId,
                },
              });

              Analytics.taskSucceeded({
                taskName: 'create-card/paste-file',
                traceId,
                source: 'cardFromClipboard',
              });
            } else {
              // @ts-expect-error TS(2345): Argument of type '{ taskName: "create-card/paste-f... Remove this comment to see the full error message
              Analytics.taskFailed({
                taskName: 'create-card/paste-file',
                traceId,
                source: 'cardFromClipboard',
              });
            }
          },
          (error) => {
            throw Analytics.taskFailed({
              taskName: 'create-card/paste-file',
              traceId,
              source: 'cardFromClipboard',
              error,
            });
          },
        );
      })
      .catch(() => {})
      .done();
  }

  renderListLimit() {
    const $listContent = $('.js-list-content', this.$el);

    const $listLimitBadge = $('.js-list-limit-badge', this.$el);

    const listLimitsEnabled = this.model
      .getBoard()
      .isListLimitsPowerUpEnabled();

    if (listLimitsEnabled) {
      const softLimit = this.model.get('softLimit');

      if (softLimit /* eslint-disable-line eqeqeq */ != null) {
        // ignore separator cards when counting for list limits
        const noSeparatorMetadata = featureFlagClient.get(
          'workflowers.unship-separator-metadata',
          false,
        );
        const cardCount = this.model.cardList.filter(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (card: any) =>
            !getSeparatorClassName(card.get('name')) ||
            (noSeparatorMetadata &&
              !doesCardOnlyHaveName({
                description: card.attributes?.desc,
                numAttachments: card.attributes?.badges?.attachments,
                numCustomFieldItems: card.customFieldItemList?.length ?? 0,
                numChecklistItems: card.attributes?.badges?.checkItems,
                numLabels: card.attributes?.idLabels?.length ?? 0,
                numMembers: card.attributes?.idMembers?.length,
                startDate: card.attributes?.start,
                dueDate: card.attributes?.due,
                cover: card.attributes?.cover,
              })),
        ).length;
        const hasExceededLimit = cardCount > softLimit;

        $listLimitBadge.text(`${cardCount} / ${softLimit}`);
        $listLimitBadge.removeClass('hide');
        $listContent.toggleClass('exceeds-list-limit', hasExceededLimit);
        return $listLimitBadge.toggleClass('mod-warning', hasExceededLimit);
      } else {
        $listContent.removeClass('exceeds-list-limit');
        $listLimitBadge.addClass('hide');
      }
    } else {
      $listContent.removeClass('exceeds-list-limit');
      $listLimitBadge.addClass('hide');
    }
  }

  onIdChange() {
    // If this list is a copy of another, and the source list has more than
    // around 50 cards, then the copied cards never render in the new, copied
    // list. This is because the copied cards make it into the model cache
    // before the new list does, which means that they can't be attached to its
    // parent list when they are inserted (because its parent list doesn't exist
    // yet).
    //
    // The solution is to wait for the copied list to exist in the model cache,
    // then manually sync with it so that the copied cards can be added to
    // this list, where they belong.
    this.model.cardList.sync();

    this.renderCardTemplateButton();
  }

  renderCardTemplateButton() {
    if (this.model.id /* eslint-disable-line eqeqeq */ != null) {
      renderComponent(
        <CardTemplatesButton
          idList={this.model.id}
          // eslint-disable-next-line react/jsx-no-bind
          onCardCreated={(card) => {
            const cardModel = ModelCache.findOne('Card', 'id', card.id);
            cardModel?.waitForId(cardModel, () => {
              this.cardListView.scrollToCardView(cardModel);
            });
          }}
        />,
        this.el.querySelector('.js-card-templates-button'),
      );
    }

    return this;
  }

  removeCardTemplateButton() {
    if ($('.js-card-templates-button', this.$el).length) {
      return ReactDOM.unmountComponentAtNode(
        // @ts-expect-error this could be null
        this.el.querySelector<HTMLElement>('.js-card-templates-button'),
      );
    }
  }
}
